import { registerLookup } from "@redriver/cinnamon";
import { getDashboardInfo } from "./actions";

export const dashboardDetailsLookup = registerLookup(
  "dashboardDetailsLookup",
  getDashboardInfo
);
